import { CALL_STATUSES, CALL_DIRECTIONS } from '@/consts';

import {
  TOGGLE_PHONE_CONNECTION,
  TOGGLE_PHONE_REGISTRATION,
  SET_CALL_REMOTE,
  SET_CALL_STATUS,
  SET_DIAL_PAD_ACTIVE,
  SET_CALL_LOGS,
  ADD_CALL,
  UPDATE_CALL_ID,
  REMOVE_CALL,
  SET_NOTIFYING_CALL_LOG,
  SET_REF,
  CLEAR_REF
} from './types';

export const INIT_STATE = {
  registered: false,
  connected: false,
  callLogs: [],
  calls: [],
  remote: '',
  volume: 0.75,
  status: CALL_STATUSES.IDLE,
  dialPadActive: false,
  notifyingCallLog: false,
  ref: {
    type: '',
    id: null
  }
};

const mutations = {
  [TOGGLE_PHONE_CONNECTION](state, val) {
    state.connected = !!val;
  },

  [TOGGLE_PHONE_REGISTRATION](state, val) {
    state.registered = !!val;
  },

  [SET_CALL_LOGS](state, logs = []) {
    state.callLogs = logs;
    state.notifyingCallLog = true;
  },

  [SET_CALL_REMOTE](state, remote) {
    state.remote = remote;
  },

  [SET_CALL_STATUS](state, status_) {
    let status = status_;
    if (!status) status = CALL_STATUSES.IDLE;
    if (Object.keys(CALL_STATUSES).indexOf(status) < 0) return;

    state.status = status;
  },

  [SET_DIAL_PAD_ACTIVE](state, val) {
    if (typeof val === 'boolean') {
      state.dialPadActive = val;
    } else {
      state.dialPadActive = !state.dialPadActive;
    }
  },

  [ADD_CALL](state, { id, session, startTime, direction, number, ref }) {
    state.calls.push({
      id,
      session,
      startTime,
      direction,
      number,
      ref
    });

    if (
      (direction === CALL_DIRECTIONS.INBOUND)
      && (state.status === CALL_STATUSES.IDLE)
    ) {
      state.status = CALL_STATUSES.HAVING_CALL;
    }
  },

  [UPDATE_CALL_ID](state, { number, id }) {
    const i = state.calls.findIndex((c) => c.number === number);
    if (i < 0) return;

    state.calls[i].id = id;
    state.calls = [...state.calls];
  },

  [REMOVE_CALL](state, id) {
    const i = state.calls.findIndex((c) => c.id === id);
    if (i < 0) return;

    if (state.calls[i].number === state.remote) {
      state.remote = '';
    }

    state.calls = [
      ...state.calls.slice(0, i),
      ...state.calls.slice(i + 1, state.calls.length)
    ];
  },

  [SET_NOTIFYING_CALL_LOG](state, val) {
    if (typeof val === 'boolean') {
      state.notifyingCallLog = val;
    } else {
      state.notifyingCallLog = !state.notifyingCallLog;
    }
  },

  [SET_REF](state, { type, refId }) {
    state.ref = {
      type,
      id: refId
    };
  },

  [CLEAR_REF](state) {
    state.ref = { ...INIT_STATE.ref };
  }
};

export default mutations;
